import { render, staticRenderFns } from "./StubComponent.vue?vue&type=template&id=030f9936&"
import script from "./StubComponent.vue?vue&type=script&lang=js&"
export * from "./StubComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports